class Video {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUI();
    this.bindEvents();
  }

  unmount() {
    this.element.removeEventListener('click', this.onClick.bind(this));
    this.ui = {};
  }

  bindUI() {
    this.ui = {};
    this.ui.$iframe = this.element.querySelector('[data-ref="video-iframe"]');
  }

  bindEvents() {
    this.element.addEventListener('click', this.onClick.bind(this));
  }

  onClick(e) {
    const target = e.currentTarget;
    if (!target.matches('[data-module="Video"]')) return;

    const iframeDataSrc = this.ui.$iframe.dataset.src;
    // Hide the image and svg icon and show iframe widow
    target.classList.add('video__vimeo--playing');
    this.ui.$iframe.setAttribute('src', iframeDataSrc);
  }
}

export default Video;
